import { useEffect, useMemo } from 'react'
import localStorage from 'sw-modules/local-storage'
import { analytics, constants } from 'helpers'
import forms from 'sw-modules/forms'

import { sortOptions, filterOptions } from './data'


const useSortForm = () => {
  const form = forms.useForm<VaultsPage.SortFormParams>({
    sort: {
      initialValue: sortOptions[1].value,
      valueType: 'string',
    },
    filter: {
      initialValue: filterOptions[0].value,
      valueType: 'string',
    },
    search: {
      valueType: 'string',
    },
  })

  const { values } = forms.useFormValues(form)

  useEffect(() => {
    const vaultsListTab = localStorage.getSessionItem(constants.localStorageNames.vaultsListTab)

    if (vaultsListTab) {
      form.fields.filter.setValue('deposits')
    }
  }, [])

  useEffect(() => {
    if (values.filter !== 'all') {
      form.fields.search.reset()
    }
  }, [ form, values.filter ])

  useEffect(() => {
    if (values.filter == 'deposits') {
      localStorage.setSessionItem(constants.localStorageNames.vaultsListTab, 'deposits')
    }
    else {
      localStorage.removeSessionItem(constants.localStorageNames.vaultsListTab)
    }
  }, [ form, values.filter ])

  useEffect(() => {
    const handleSetSort = (field: Forms.Field<VaultsPage.SortFormParams['sort']>) => {
      if (field.value) {
        analytics.statistics.sendEvent('setVaultsTabSort', { value: field.value })
      }
    }

    const handleSetFilter = (field: Forms.Field<VaultsPage.SortFormParams['filter']>) => {
      if (field.value) {
        analytics.statistics.sendEvent('setVaultsTabFilter', { value: field.value })
      }
    }

    form.fields.sort.subscribe('change', handleSetSort)
    form.fields.filter.subscribe('change', handleSetFilter)

    return () => {
      form.fields.sort.unsubscribe('change', handleSetSort)
      form.fields.filter.unsubscribe('change', handleSetFilter)
    }
  }, [])

  return useMemo(() => ({
    ...values,
    sortForm: form,
  }), [ values, form ])
}


export default useSortForm
